import React from 'react'
import { Card, Typography, Flex, Select } from 'antd'
import { MessageOutlined } from '@ant-design/icons'
import { promptVersionOptions } from '@/data'

const { Text } = Typography

interface AIChatLanderBuilderProps {
  promptVersion: string | null
  onPromptVersionChange: (version: string | null) => void
  title?: string
  showBrandingHint?: boolean
}

export const AIChatLanderBuilder: React.FC<AIChatLanderBuilderProps> = ({
  promptVersion,
  onPromptVersionChange,
  title = 'AI Chat Lander',
  showBrandingHint = true,
}) => {
  return (
    <Card title={title} style={{ maxWidth: 1100 }}>
      <Flex vertical gap="middle">
        <div>
          <Text strong>Prompt Version</Text>
          <Select
            placeholder="Select a prompt version..."
            value={promptVersion}
            onChange={(value) => onPromptVersionChange(value)}
            style={{ width: '100%', marginTop: 8 }}
            size="large"
            options={promptVersionOptions}
          />
        </div>
        <Flex vertical gap="small" align="center" style={{ padding: '24px 0' }}>
          <MessageOutlined style={{ fontSize: 32, color: '#bfbfbf' }} />
          <Text type="secondary" style={{ textAlign: 'center', maxWidth: 480 }}>
            This template has no form steps — visitors land on the page and the
            AI chat handles the conversation.
            {showBrandingHint &&
              ' Configure the logo and color palette in the Branding section above.'}
          </Text>
        </Flex>
      </Flex>
    </Card>
  )
}
